import React from 'react';
// import __ from 'lodash';
 
class DropdownProvinsi extends React.Component {
    render() {
        return (
            this.props.provinsi.map(val =>
                <option key={val.ID_PROVINSI} value={val.ID_PROVINSI}>{val.NAMA_PROVINSI}</option>
            )
        )
    }
}

export default DropdownProvinsi;